// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"3aa2faa8","631":"6702698e"}[chunkId] + ".chunk.css";
};